import { RootState } from 'store';
import { createSelector } from '@reduxjs/toolkit';

const getTreeState = (state: RootState) => state.treeCard;

export const getTreeCurrentCardData = createSelector(getTreeState, ({ currentCardData }) => currentCardData);
export const getIsOpenCardInfo = createSelector(getTreeState, ({ isOpenCardInfo }) => isOpenCardInfo);
export const getIsClickedCard = createSelector(getTreeState, ({ isClickedCard }) => isClickedCard);